export default __webpack_public_path__ + "static/media/cultureIcon.2d1b68c5.png";